import React from 'react';
import { motion } from 'framer-motion';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppButton = () => {
  const whatsappNumber = '918983325227'; // Country code + number
  const whatsappUrl = `https://wa.me/${whatsappNumber}`;

  return (
    <motion.a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-16 h-16 bg-white/5 backdrop-blur-md border border-white/10 rounded-full flex items-center justify-center hover:bg-white/20 hover:scale-110 group transition-all duration-300 ease-in-out shadow-lg shadow-black/20"
      initial={{ y: 50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 1, duration: 0.3, ease: "easeOut" }}
      aria-label="Chat on WhatsApp"
    >
      {React.createElement(FaWhatsapp as any, { className: "text-white group-hover:text-svnate-lightTeal text-3xl transition-colors duration-300 ease-in-out" })}
      
      {/* Tooltip */}
      <span className="absolute right-full mr-4 px-4 py-2 bg-black/80 backdrop-blur-md border border-white/10 rounded-lg text-white text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out pointer-events-none">
        Chat with us!
      </span>
    </motion.a>
  );
};

export default WhatsAppButton;
